import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Style.css";
import Swal from "sweetalert2";

const Sidebar = () => {
  const [isActive, setIsActive] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsActive(!isActive);
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  return (
    <div id="sidebar" className={isActive ? "active" : ""}>
      <div className={`sidebar-wrapper ${isActive ? "active" : ""}`}>
        <div className="sidebar-header">
          <div className="d-flex justify-content-between">
            <div className="logo">
              <Link to="/Dashboard">
                <img src="assets/images/logo/logo.png" alt="Logo" />
              </Link>
            </div>
            <div className="toggler">
              <button
                onClick={toggleSidebar}
                className="sidebar-hide d-xl-none d-block"
              >
                <i className="bi bi-x bi-middle"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="sidebar-menu">
          <ul className="menu">
            <li
              className={`sidebar-item ${isActiveLink("/Dashboard") ? "active" : ""
                }`}
            >
              <Link to="/Dashboard" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Dashboard</span>
              </Link>
            </li>
            {/* <li className={`sidebar-item ${isActiveLink('/CategoriesList') ? 'active' : ''}`}>
              <Link to="/CategoriesList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Category</span>
              </Link>
            </li>
            <li className={`sidebar-item ${isActiveLink('/SubCategoryList') ? 'active' : ''}`}>
              <Link to="/SubCategoryList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>SubCategory</span>
              </Link>
            </li> */}
            <li
              className={`sidebar-item ${isActiveLink("/StaffList") ? "active" : ""
                }`}
            >
              <Link to="/StaffList" className="sidebar-link">
                <i className="bi bi-person-fill"></i>
                <span>Staff</span>
              </Link>
            </li>

            <li
              className={`sidebar-item ${isActiveLink("/CustomerList") ? "active" : ""
                }`}
            >
              <Link to="/CustomerList" className="sidebar-link">
                <i className="bi bi-person-fill"></i>
                <span>Customer </span>
              </Link>
            </li>

            <li
              className={`sidebar-item ${isActiveLink("/WatchmenList") ? "active" : ""
                }`}
            >
              <Link to="/WatchmenList" className="sidebar-link">
                <i className="bi bi-shield-lock-fill"></i>
                <span>Watchman</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/TaskList") ? "active" : ""
                }`}
            >
              <Link to="/TaskList" className="sidebar-link">
                <i className="bi bi-check2-square"></i>
                <span>Task</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/InWordProductsList") ? "active" : ""
                }`}
            >
              <Link to="/InWordProductsList" className="sidebar-link">
                <i className="bi bi-person-badge-fill"></i>
                <span>In-Out Products</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/WalletList") ? "active" : ""
                }`}
            >
              <Link to="/WalletList" className="sidebar-link">
                <i className="bi bi-wallet-fill"></i>
                <span>Cash Wallet</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/FineList") ? "active" : ""
                }`}
            >
              <Link to="/FineList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Fine Wallet</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/MeterModuleList") ? "active" : ""
                }`}
            >
              <Link to="/MeterModuleList" className="sidebar-link">
                <i className="bi bi-speedometer2"></i>
                <span>Meter Module</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/LeadsList") ? "active" : ""
                }`}
            >
              <Link to="/LeadsList" className="sidebar-link">
                <i className="bi bi-person-lines-fill"></i>
                <span>Sales Leads</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/SalesVisitsList") ? "active" : ""
                }`}
            >
              <Link to="/SalesVisitsList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Sales Visits</span>
              </Link>
            </li>

            <li
              className={`sidebar-item ${isActiveLink("/VisitsList") ? "active" : ""
                }`}
            >
              <Link to="/VisitsList" className="sidebar-link">
                <i className="bi bi-person-fill"></i>
                <span>Outdoor Visits</span>
              </Link>
            </li>

            <li
              className={`sidebar-item ${isActiveLink("/PlatingList") ? "active" : ""
                }`}
            >
              <Link to="/PlatingList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Plating</span>
              </Link>
            </li>
            {/* <li
              className={`sidebar-item ${
                isActiveLink("/LeaveList") ? "active" : ""
              }`}
            >
              <Link to="/LeaveList" className="sidebar-link">
                <i className="bi bi-door-open-fill"></i>
                <span>Leave</span>
              </Link>
            </li> */}


            {/* <li className={`sidebar-item ${isActiveLink('/VPList') ? 'active' : ''}`}>
              <Link to="/VPList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Vpp</span>
              </Link>
            </li> */}
            {/* <li className={`sidebar-item ${isActiveLink('/CatalogueList') ? 'active' : ''}`}>
              <Link to="/CatalogueList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Forming Catalogue</span>
              </Link>
            </li> */}
            {/* <li className={`sidebar-item ${isActiveLink('/GoldCatalogueList') ? 'active' : ''}`}>
              <Link to="/GoldCatalogueList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span> Catalogue</span>
              </Link>
            </li> */}
            {/* <li className={`sidebar-item ${isActiveLink('/SafeModuleList') ? 'active' : ''}`}>
              <Link to="/SafeModuleList" className="sidebar-link">
              <i className="bi bi-shield-lock-fill"></i>
              <span>Safe Module</span>
              </Link>
            </li> */}


            {/* <li className={`sidebar-item ${isActiveLink('/OutdoorProductList') ? 'active' : ''}`}>
              <Link to="/OutdoorProductList" className="sidebar-link">
              <i className="bi bi-box"></i>
              <span>Out Product</span>
              </Link>
            </li> */}
            {/* <li
              className={`sidebar-item ${
                isActiveLink("/BillModuleList") ? "active" : ""
              }`}
            >
              <Link to="/BillModuleList" className="sidebar-link">
                <i className="bi bi-receipt-cutoff"></i>
                <span>Bill Module</span>
              </Link>
            </li> */}
            <li
              className={`sidebar-item ${isActiveLink("/SalesStockList") ? "active" : ""
                }`}
            >
              <Link to="/SalesStockList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Sales Stock</span>
              </Link>
            </li>
            {/* <li
              className={`sidebar-item ${isActiveLink("/ParcelList") ? "active" : ""
                }`}
            >
              <Link to="/ParcelList" className="sidebar-link">
                <i className="bi bi-box-seam"></i>
                <span>Parcel</span>
              </Link>
            </li> */}

            <li
              className={`sidebar-item ${
                isActiveLink("/BazarList") ? "active" : ""
              }`}
            >
              <Link to="/BazarList" className="sidebar-link">
                <i className="bi bi-shop"></i>
                <span>BazarList</span>
              </Link>
            </li>
            {/* <li
              className={`sidebar-item ${isActiveLink("/OrderLeadList") ? "active" : ""
                }`}
            >
              <Link to="/OrderLeadList" className="sidebar-link">
                <i className="bi bi-bag-check-fill"></i>
                <span>Order Leads</span>
              </Link>
            </li> */}
            <li
              className={`sidebar-item ${isActiveLink("/OfficeStocksList") ? "active" : ""
                }`}
            >
              <Link to="/OfficeStocksList" className="sidebar-link">
                <i className="bi bi-building"></i>
                <span>Office Stocks</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/RawStocksList") ? "active" : ""
                }`}
            >
              <Link to="/RawStocksList" className="sidebar-link">
                <i className="bi bi-box-seam"></i>
                <span>Raw Stock </span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/RemindersList") ? "active" : ""
                }`}
            >
              <Link to="/RemindersList" className="sidebar-link">
                <i className="bi bi-bell-fill"></i>
                <span>Reminder</span>
              </Link>
            </li>
            <li
              className={`sidebar-item ${isActiveLink("/ReportsList") ? "active" : ""
                }`}
            >
              <Link to="/ReportsList" className="sidebar-link">
                <i className="bi bi-file-earmark-bar-graph"></i>
                <span>Reports </span>
              </Link>
            </li>


            <li
              className={`sidebar-item ${
                isActiveLink("/login") ? "active" : ""
              }`}
            >
              <Link
                to="#"
                className="sidebar-link"
                onClick={(e) => {
                  e.preventDefault();

                  Swal.fire({
                    title: "Are you sure?",
                    text: "You will be logged out from your session.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, Logout",
                    cancelButtonText: "Cancel",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Clear all user data from storage
                      localStorage.clear();
                      sessionStorage.clear();

                      // Redirect to login page
                      window.location.href = "/";
                    }
                  });
                }}
              >
                <i className="bi bi-box-arrow-right"></i>
                <span>Logout</span>
              </Link>
            </li>

            {/* <li className={`sidebar-item ${isActiveLink('/JobworkList') ? 'active' : ''}`}>
              <Link to="/JobworkList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Jobwork </span>
              </Link>
            </li>
            <li className={`sidebar-item ${isActiveLink('/OrderList') ? 'active' : ''}`}>
              <Link to="/OrderList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Order </span>
              </Link>
            </li>
            <li className={`sidebar-item ${isActiveLink('/TodayKarigarDeliveryList') ? 'active' : ''}`}>
              <Link to="/TodayKarigarDeliveryList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Karigar Delivery </span>
              </Link>
            </li>
            <li className={`sidebar-item ${isActiveLink('/GoldRateList') ? 'active' : ''}`}>
              <Link to="/GoldRateList" className="sidebar-link">
                <i className="bi bi-grid-fill"></i>
                <span>Gold Rate </span>
              </Link>
            </li> */}

            {/* <li className="sidebar-item has-sub">
              <a href="#" className="sidebar-link">
                <i className="bi bi-stack"></i>
                <span>Layouts</span>
              </a>
              <ul className="submenu">
                <li>
                  <a href="layout-default.html">Default Layout</a>
                </li>
                <li>
                  <a href="layout-vertical-1.html">Vertical #1</a>
                </li>
                <li>
                  <a href="layout-vertical-2.html">Vertical #2</a>
                </li>
                <li>
                  <a href="layout-vertical-3.html">Vertical #3</a>
                </li>
                <li>
                  <a href="layout-vertical-4.html">Vertical #4</a>
                </li>
                <li>
                  <a href="layout-vertical-5.html">Vertical #5</a>
                </li>
                <li>
                  <a href="layout-horizontal.html">Horizontal</a>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
        <button className="sidebar-toggler btn x" onClick={toggleSidebar}>
          <i data-feather="x"></i>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
